module.exports = __webpack_public_path__ + "static/gallery-9-de69b6283003994ddde2031d2bbdd6e3.jpg";